"use client";
import * as React from "react";
const SvgContractSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M0 0h13.521v2.91H12.02V1.454H1.502v13.09h9.015V16H0V0Zm3.005 11.636H5.37v1.455H3.005v-1.455Zm9.808-7.958L16 6.763l-1.594 1.543-3.187-3.085 1.594-1.543Zm-5.4 2.963 2.763-.374 3.175 3.074-.386 2.675-6.94 1.344 1.388-6.72Zm1.695 3.735a.769.769 0 0 0 1.062 0 .711.711 0 0 0 0-1.029.769.769 0 0 0-1.062 0 .711.711 0 0 0 0 1.029Z", clipRule: "evenodd" }));
export {
  SvgContractSharp as default
};
